/* eslint-disable no-unused-vars */

import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';
import apiClient from "../services/api/apiClient"
import {fetchCurrentUser} from "../connectors/Users/actions";

const mapStateToProps = state => ({
  authenticated: state.authentication.authenticated,
    accessToken: state.authentication.accessToken,
    devices: state.devices.map,

});

const mapDispatchToProps = dispatch => ({
    fetchCurrentUser: () => dispatch(fetchCurrentUser()),
});

/**
 * ProtectedRoutes
 */
class ProtectedRoutes extends PureComponent {
  static propTypes = {
    //authenticated: PropTypes.bool.isRequired,
      accessToken: PropTypes.string.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    children: PropTypes.node,
    redirectTo: PropTypes.string,
  }

  static defaultProps = {
    children: null,
    redirectTo: '/login',
  }

  componentDidMount() {
    var redirect = this.props.redirectTo;

    //if(Object.keys(this.props.devices).length == 0) redirect = "/onboarding"
    if (this.props.authenticated === false) {
      this.props.history.push(redirect);
    } else if(this.props.accessToken === "" && redirect === "/onboarding") {
        //this.props.history.push(redirect);

    } else {
        const token = this.props.accessToken;
        apiClient.defaults.headers.common['Authorization'] = "Bearer " +token;
        this.props.fetchCurrentUser();
        // apiClient.interceptors.request.use(function (config) {
        //
        //     config.headers.Authorization =  token;
        //
        //     return config;
        // });
    }
  }

  componentWillReceiveProps() {
      var redirect = this.props.redirectTo;

      if (this.props.authenticated === false){
        redirect="/login"
        this.props.history.push(redirect);
      } else {
        if(Object.keys(this.props.devices).length === 0) {
          redirect="/onboarding"
        }
      }


      if (redirect === "/onboarding") {
          this.props.history.push(redirect);
      } else {
          const token = this.props.accessToken;
          apiClient.defaults.headers.common['Authorization'] = "Bearer " +token;
          // apiClient.interceptors.request.use(function (config) {
          //
          //     config.headers.Authorization =  token;
          //
          //     return config;
          // });
      }
  }

  render() {
    return (<Fragment>{this.props.children}</Fragment>);
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProtectedRoutes));
